import { WritableAtom } from 'jotai'

import { QR_TYPE, TQrContent } from '../generatorTypes'
import { appContentAtom } from '../qrTypes/App/AppContentState'
import { businessContentAtom } from '../qrTypes/BusinessPage/BusinessPageContentState'
import { facebookContentAtom } from '../qrTypes/Facebook/FacebookContentState'
import { imagesContentAtom } from '../qrTypes/Images/imagesContentState'
import { menuContentAtom } from '../qrTypes/Menu'
import { pdfContentAtom } from '../qrTypes/Pdf/PdfContentState'
import { plainTextContentAtom } from '../qrTypes/PlainText/PlainTextContentState'
import { socialMediaContentAtom } from '../qrTypes/SocialMedia/SocialMediaContentState'
import { websiteUrlContentAtom } from '../qrTypes/Url/WebsiteUrlContentState'
import { vCardContentAtom } from '../qrTypes/VCard/shared'
import { videoContentAtom } from '../qrTypes/Video/VideoContentState'
import { wifiContentAtom } from '../qrTypes/Wifi/WifiContentState'

export type TQrContentAtom = WritableAtom<TQrContent, [TQrContent], void>

export const QR_TYPE_TO_CONTENT_ATOM = {
	[QR_TYPE.App]: appContentAtom,
	[QR_TYPE.Facebook]: facebookContentAtom,
	[QR_TYPE.VCard]: vCardContentAtom,
	[QR_TYPE.Images]: imagesContentAtom,
	[QR_TYPE.PlainText]: plainTextContentAtom,
	[QR_TYPE.BusinessPage]: businessContentAtom,
	[QR_TYPE.Video]: videoContentAtom,
	[QR_TYPE.Wifi]: wifiContentAtom,
	[QR_TYPE.SocialMedia]: socialMediaContentAtom,
	[QR_TYPE.Menu]: menuContentAtom,
	[QR_TYPE.Url]: websiteUrlContentAtom,
	[QR_TYPE.Pdf]: pdfContentAtom,
} as unknown as Record<QR_TYPE, TQrContentAtom>
